/* eslint-disable react-hooks/exhaustive-deps */
import { cloneDeep, get, range } from 'lodash';
import React, { useEffect, useState } from 'react';
import { editRequestReservations } from '../../apis/admin/seminar';
import useForm from '../../hooks/useForm';
import systemAlert from '../../utils/systemAlert';
import { toast } from '../../utils/toast';
import Form from '../Form';
import Modal, { ModalHeader } from '../Modal';
import { getCitys, getRegions } from '../../apis/admin/region';
import { isEmpty } from '../../utils/lodashExtend';

const defaultForm = {
  approvalStatus: "",
  paymentStatus: "",
  applicantName: "",
  applicantMobile: "",
  applicantMemo: "",
  companyName: "",
  memo: "",
  participants: [],
  requestInfo: "",
  regionCode: "",
  address: "",
  addressDetail: "",
  zipCode: "",
  placeType: "",
  mapUrl: "",
};
const RequestReservation = (props) => {
  const { open, setOpen, submit, selectedItem, setSelectedItem } = props;
  const [fields, setFields] = useState([]);

  const [participantCnt, setParticipantCnt] = useState(0);
  const [regions, setRegions] = useState([]);
  const [citys, setCitys] = useState([]);

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    if (setSelectedItem) {
      setSelectedItem(null);
    }

    setCitys([]);
  };

  const _submit = (form) => {
    const data = {
      approvalStatus: form.approvalStatus,
      paymentStatus: form.paymentStatus,
      memo: form.memo || "",
      applicantName: form.applicantName,
      applicantMobile: form.applicantMobile,
      applicantMemo: form.applicantMemo,
      companyName: form.companyName,
      participants: form.participants,
      requestInfo: form.requestInfo,
      placeType: form.placeType,
      ...(form.placeType === "1" ? {
        regionDivisionIdx: form.regionDivisionIdx
      } : {
        address: form.address,
        addressDetail: form.addressDetail,
        zipCode: form.zipCode,
      }),
      mapUrl: form.mapUrl,
    };

    systemAlert("예약정보를 정말 변경하시겠습니까?",
      {
        buttons: [
          {
            label: "취소",
            color: "text",
          },
          {
            label: '변경',
            onClick: () => {
              editRequestReservations(selectedItem.idx, data)
                .then(() => {
                  toast.success("변경되었습니다.");
                  cancel();
                  submit && submit();
                }).catch(err => {
                  console.error(err);
                });
            }
          }
        ]
      });
  };

  const getRegionList = () => {
    getRegions().then(res => {
      setRegions(
        res.regions
          .map(item => ({ label: item.region, value: item.regionCode }))
      );
    });
  };

  const getCityList = (regionCode) => {
    getCitys(regionCode)
      .then(res => {
        if (selectedItem?.regionDivision?.regionCode !== form.regionCode) {
          handleOnChange({ cityCode: get(res, "citys[0].cityCode", "") });
        }
        setCitys(res.citys);
      });
  };


  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setOriginForm,
    setValidateFields,
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {
    setValidateFields(fields);
    if (!isEmpty(selectedItem)) {
      setForm({
        ...selectedItem, paymentStatus: get(selectedItem, "paymentStatus") + "",
        regionCode: selectedItem?.regionDivision?.regionCode,
        cityCode: selectedItem?.regionDivision?.cityCode,
      });
      setOriginForm({
        ...selectedItem, paymentStatus: get(selectedItem, "paymentStatus") + "",
        regionCode: selectedItem?.regionDivision?.regionCode,
        cityCode: selectedItem?.regionDivision?.cityCode,
      });
      setParticipantCnt(selectedItem?.participants?.length);
    } else {
      setForm(defaultForm);
      setOriginForm(defaultForm);
    }

    getRegionList();
  }, [open, selectedItem]);

  useEffect(() => {
    if (!isEmpty(form.regionCode)) {
      getCityList(form.regionCode);
    }
  }, [form.regionCode]);

  useEffect(() => {
    const _fields = [
      [
        { title: "그룹명", key: "companyName", type: "input" },
      ],
      [
        { title: "신청자명", key: "applicantName", type: "input" },
        { title: "신청자 번호", key: "applicantMobile", type: "input" },
      ],
      [
        {
          title: "일정",
          key: "seminarTime",
          type: "input",
        }
      ],
      [{
        title: "장소 유무",
        key: "placeType",
        type: "radio",
        options: {
          list: [
            { label: '장소 없음', value: "1" },
            { label: '직접 대관', value: "2" },
            { label: '기타 장소', value: "3" }
          ]
        },
      }],
      ...(
        form?.placeType === "1" ? [
          [{
            title: "지역 선택",
            key: "regionCode",
            type: "select",
            options: {
              list: regions
            },
          }, {
            title: ' ',
            key: "cityCode",
            type: "select",
            options: {
              list: () => citys.map(item => ({ label: item.city, value: item.cityCode }))
            },
            onChanged: ({ form, onChange }) => {
              onChange({ regionDivisionIdx: citys.find(f => f.cityCode === form.cityCode)?.idx });
            }
          }]
        ] : [
          {
            title: "주소",
            type: "address",
            required: true,
          }
        ]
      ),
      [
        {
          title: "지도 주소 URL",
          key: "mapUrl",
          type: "input"
        }
      ],
      ...(range(0, participantCnt).map(num => {
        return [{
          title: `참여자${num + 1} 이름`, key: `participants[${num}].name`, type: "input",
        }, {
          title: `참여자${num + 1} 번호`, key: `participants[${num}].mobile`, type: "input",
        }];
      })),

      [
        ...(participantCnt + 1 > selectedItem?.seminarRequest?.minPeople ?
          [
            {
              title: <> </>,
              type: "button",
              color: "gray-line",
              label: "참여자 추가",
              action: () => {
                setParticipantCnt(participantCnt + 1);
              },
              labelWidth: 100,
            },
            {
              title: <> </>,
              type: "button",
              color: "gray-line",
              label: "참여자 축소",
              action: () => {
                const participants = cloneDeep(form?.participants);
                participants.splice(participants.length - 1, 1);
                setParticipantCnt(participantCnt - 1);

              },
              labelWidth: 100,
            },
          ] :
          [{
            title: <> </>,
            type: "button",
            color: "gray-line",
            label: "참여자 추가",
            action: () => {
              setParticipantCnt(participantCnt + 1);
            },
            labelWidth: 100,
            style: { width: "100%" }
          },
          ]
        )
      ],

      [
        {
          title: "추가 요청사항",
          key: "requestInfo",
          type: "textarea",
          readOnly: true,
        }
      ],
      [
        {
          title: "예약상태",
          key: "approvalStatus",
          type: "select",
          options: {
            list: [
              { label: "대기", value: "wait" },
              { label: "예약완료", value: "approval" },
              { label: "반려", value: "denied" },
            ]
          }
        },
        {
          title: "결재상태",
          key: "paymentStatus",
          type: "select",
          options: {
            list: [
              { label: "결제", value: "true" },
              { label: "미결재", value: "false" },
            ]
          }
        },
      ],
      [
        {
          title: "메모",
          key: "memo",
          type: "textarea"
        }
      ]
    ];

    setFields(_fields);
  }, [form.placeType, regions, citys, selectedItem, participantCnt]);

  return (
    <Modal
      isOpen={open}
      close={cancel}
    >

      <div className="item-write">
        <ModalHeader>
          {`${selectedItem?.user?.name}님 상태 변경`}
        </ModalHeader>
        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={"변경"}
          submit={handleSubmit}
          cancel={cancel}
        />
      </div>
    </Modal>
  );
};

export default RequestReservation;